import React, { useRef, useState } from 'react';
import { IconButton, Stack, Popover, ClickAwayListener, Paper } from '@mui/material';
import { useCurrentEditor, useEditorState } from '@tiptap/react';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import BrokerageColourPicker from '@/components/BrokerageColourPicker';

const ToolbarColourPicker = () => {
	const [showPicker, setShowPicker] = useState(false);

	const ref = useRef();
	const popperRef = useRef();
	const [anchorEl, setAnchorEl] = useState(null);

	const { editor } = useCurrentEditor();

	const editorState = useEditorState({
		editor,
		selector: (ctx) => {
			return {
				color: ctx.editor?.getAttributes('textStyle')?.color,
				isActiveColour: (color) => ctx.editor?.isActive('textStyle', { color }),
			};
		},
	});

	const handleColourChange = (colourChange) => {
		const newColour = (colourChange?.toString() ?? '').startsWith('#')
			? colourChange
			: `#${colourChange}`;

		const activeElement = document.activeElement;

		if (colourChange === 'transparent') {
			editor.chain().focus().unsetColor().run();
		} else {
			editor.chain().focus().setColor(newColour).run();
		}

		if (
			activeElement &&
			(activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')
		) {
			setTimeout(() => {
				activeElement.focus();
				if (activeElement.setSelectionRange) {
					const length = activeElement.value.length;
					activeElement.setSelectionRange(length, length);
				}
			}, 0);
		}
	};

	const showColourPicker = () => {
		setAnchorEl(ref.current);
		setShowPicker(!showPicker);
	};

	const handleClose = () => {
		setShowPicker(false);
		setAnchorEl(null);
	};

	return (
		<>
			<IconButton ref={ref} size='small' onClick={showColourPicker}>
				<span
					style={{
						position: 'relative',
						display: 'inline-flex',
					}}
				>
					<FormatColorTextIcon
						style={{
							display: 'block',
							mask: 'linear-gradient(to bottom, black 75%, transparent 75%)',
							WebkitMask: 'linear-gradient(to bottom, black 75%, transparent 75%)',
						}}
					/>

					<FormatColorTextIcon
						style={{
							color: editorState.color,
							position: 'absolute',
							top: 0,
							left: 0,
							height: '100%',
							width: '100%',
							clipPath: 'inset(75% 0 0 0)',
							pointerEvents: 'none',
						}}
					/>
				</span>
			</IconButton>
			{showPicker && (
				<Popover
					ref={popperRef}
					anchorEl={anchorEl}
					placement={'left'}
					open={showPicker}
					sx={{
						zIndex: (theme) => theme.zIndex.modal + 10,
						pointerEvents: 'auto',
					}}
				>
					<ClickAwayListener onClickAway={handleClose}>
						<Paper elevation={1}>
							<Stack
								spacing={1}
								padding={1}
								sx={{
									'& .sketch-picker': {
										background: 'none !important',
										boxShadow: 'none !important',
										padding: '0 !important',
										borderRadius: '0 !important',
									},
								}}
							>
								<BrokerageColourPicker
									value={editorState.color}
									setValue={(v) => handleColourChange(v)}
									canRemove={true}
								/>
							</Stack>
						</Paper>
					</ClickAwayListener>
				</Popover>
			)}
		</>
	);
};

export default ToolbarColourPicker;
